import styled from 'styled-components';
import { Row, Col } from 'antd';
import { NoData } from '../../CommonComponents/commonStyles';

export const NoAdvisorData = styled(NoData)`
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;

export const FinancialAdvisorDashboardBody = styled.div``;

export const AccountDetailContainer = styled.div`
  padding: 0;
  max-width: 1180px;
  margin: 0 auto;
  background: ${props => props.theme.backgroundColor.layoutDark};
  justify-content: space-between;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 0px;
    padding: 0px;
  }
`;

export const AdvisorFixedWidth = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 0;
  @media (max-width: 1440px) {
    padding-left: 25px;
    padding-right: 25px;
  }
  @media (max-width: 576px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const CardRow = styled(Row)`
  display: flex !important;
  flex-wrap: wrap;
  > * {
    flex: 1;
  }
  > div:nth-child(3n) {
    margin-right: 0px;
  }
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    > div {
      margin-right: 0px;
    }
  }
`;

export const AdvisorHeader = styled.h1`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: 42px;
  letter-spacing: 0.5px;
  line-height: ${props => props.theme.lineHeight.h2};
  font-style: normal;
  font-stretch: normal;
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 36px;
  }
`;

export const AdvisorDetailsCol = styled(Col)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100%;
  }
`;

export const AccountCount = styled.h2`
  font-family: ${props => props.theme.fontFamily.helveticaNeueLight};
  font-size: 40px;
  letter-spacing: 0.5px;
  font-style: normal;
  font-stretch: normal;
  color: ${props => props.theme.fontColors.textColor};
  line-height: normal;
  font-weight: 300;
  margin: 0;
  padding-right: 15px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 28px;
  }
`;

export const AmountWrap = styled.h3`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: 40px;
  letter-spacing: 0.5px;
  font-style: normal;
  font-stretch: normal;
  color: ${props => props.theme.fontColors.thead};
  line-height: normal;
  font-weight: 300;
  margin: 0;
  padding: 0 15px 0 19px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 28px;
    padding: 10px 0 5px 0;
  }
`;

export const FlexCol = styled(Col)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  > div {
    display: flex;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
    width: 100%;
    justify-content: flex-start;
    align-items: flex-start;
    > div {
      padding-bottom: 10px;
      width: 100%;
      border-bottom: 1px solid #d4d4d4;
    }
  }
`;

export const LazyloadWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 40px;
  }
`;

export const HR = styled.div`
  border-bottom: 1px solid #d4d4d4;
`;

export const ColWrapper = styled(Col)`
  display: flex;
  justify-content: flex-end;
`;
